import { Box, Chip, Paper, Typography, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown,
  faArrowsLeftRight
} from "@fortawesome/free-solid-svg-icons";

import Link from "../../../atoms/mui/Link";

const TREND_ICON_MAP = {
  up: faArrowUp,
  down: faArrowDown,
  flat: faArrowsLeftRight
};

const ScoutMetricCard = ({
  label,
  value,
  unit,
  confidence,
  trend,
  helpText
}) => {
  const { palette } = useTheme();
  const trendIcon = trend ? TREND_ICON_MAP[trend] : null;
  const displayValue =
    typeof value === "number" ? value.toLocaleString() : value;

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        maxWidth: 360
      }}
    >
      <Typography variant="caption" color="textSecondary">
        {label}
      </Typography>
      <Box display="flex" alignItems="baseline" style={{ gap: 8 }}>
        <Typography variant="h3" color="textPrimary">
          {displayValue}
        </Typography>
        {unit && (
          <Typography variant="subtitle1" color="textSecondary">
            {unit}
          </Typography>
        )}
        {trendIcon && (
          <FontAwesomeIcon
            icon={trendIcon}
            color={palette.text.secondary}
            style={{ fontSize: 14 }}
          />
        )}
      </Box>
      {confidence && (
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          <Link href="/explorer/upgrade">
            <Chip
              label={`${confidence} confidence`}
              size="small"
              style={{
                backgroundColor: palette.backgroundGray.main,
                color: palette.text.secondary,
                cursor: "pointer"
              }}
            />
          </Link>
        </Box>
      )}
      {helpText && (
        <Typography variant="caption" color="textSecondary">
          {helpText}
        </Typography>
      )}
    </Paper>
  );
};

export default ScoutMetricCard;
